/**
 * Inclusion type use in case of Colonoscopy module activation
 */
export enum InclusionTypes {
  fit = 'fit',
  colo = 'colonoscopy',
  refusal = 'refusal',
}

export enum ProInclusionTypes {
  fit = 'fit',
  colo = 'colo',
  advice = 'advice',
}

/**
 * The different template types used to download a document
 */
export enum TemplateTypes {
  /** Follow up PDF for a FIT (downloaded by a pharmacist) */
  FollowUpFIT = 'FollowUpFIT',
  /** Follow up PDF for a colo (downloaded by a doctor) */
  FollowUpColo = 'FollowUpColo',
  /** Confirmation PDF for a FIT (downloaded by a participant) */
  ConfirmationFIT = 'ConfirmationFIT',
  /** Confirmation PDF for a colo (downloaded by a participant) */
  ConfirmationColo = 'ConfirmationColo',
  /** Confirmation PDF for a non-participation (downloaded by a participant) */
  ConfirmationNonParticipation = 'ConfirmationNonParticipation',
}

/**
 * These are MC-SIS COD_NAME that will be sent to the queue
 */

export enum ConsultationTypes {
  short = 'INC_SHORT_CONSULTATION',
  long = 'INC_LONG_CONSULTATION',
  free = 'INC_FREE_CONSULTATION',
}

export enum LongConsultationReasons {
  alloPhone = 'P_ALLOPHONE',
  underGuardianship = 'P_SOUS_TUTELLE',
  traumaticMedicalHistory = 'P_ANT_MED_TRAUMA',
  cognitiveDisorders = 'P_TROUBLES_COGNITIFS',
  mentalDisorders = 'P_TROUBLES_PHYSIQUE',
  otherReason = 'P_OTHER_REASON',
}

export enum InclusionAdvice {
  wantColo = 'WANT_COLO',
  wantThink = 'WANT_THINK',
}

/**
 * List of all languages in MC-SIS
 */
export enum CorrespondenceLanguages {
  DE,
  EN,
  FR,
  IT,
  RM,
  CS,
  ES,
  HU,
  NL,
  NO,
  PL,
  PT,
  RU,
  SH,
  SI,
  SQ,
  SR,
  TA,
  TR,
}

export enum PhoneNumberCountries {
  CH,
  FR,
  IT,
  DE,
}
